import React from 'react';
import { InputField, InputFieldParams } from '../input-field';

export const TextField = (props: Omit<InputFieldParams<string>, 'type'>) => {
  return <InputField {...props} />;
};
